/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { CircularProgress } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { Button } from "components/button";
import { CustomInput } from "components/custom-input";
import { Input } from "components/input";
import { ErrorP } from "components/input/input.style";
import { useThisUser } from "contexts/user-context";
import { signupAction } from "pages/api/api_actions";
import { TC } from "../signp.styles";
import { userSchema } from "./input-validations";

type UseRegisterForm = {
   firstname: string;
   lastname: string;
   domain: string;
   email: string;
   password: string;
   confirmPassword?: string;
   acceptTerms?: boolean;
};

const Step1 = () => {
   const [isLoading, setIsLoading] = useState(false);
   const router = useRouter();
   const { dispatch } = useThisUser();
   const [userState, setUserState] = useState<UseRegisterForm>();
   const {
      register,
      handleSubmit,
      formState: { errors },
      watch,
   } = useForm<UseRegisterForm>({
      resolver: yupResolver(userSchema),
   });
   const onSubmit = (data: UseRegisterForm) => {
      // localStorage.clear();
      setIsLoading(true);
      console.log(data);
      localStorage.setItem("signupEmail", data.email);
      // dispatch({ type: "set_user", payload: data });
      delete data.confirmPassword;
      delete data.acceptTerms;
      signupAction(data)
         .then((response) => {
            console.log(response.data);
            if (response.data.success) {
               console.log(response.data.data.token);
               dispatch({ type: "set_token", payload: response.data.data.token });
               localStorage.setItem("token", response.data.data.token);
               return response;
               // router.push("/signup/step-2");
            } else {
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
               });
               setIsLoading(false);
            }
         })
         .then((response) => {
            if (response?.data.success) {
               console.log(response.data.data.token);
               dispatch({ type: "set_token", payload: response.data.data.token });
               router.push("/signup/step-3");
               // router.push("/signup/step-2");
            }
         })
         .catch((err) => {
            console.log(err);

            err.response && console.log(err.response);
            err.response &&
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: `${err.response.data.message}`,
               });
            setIsLoading(false);
         });
      localStorage.setItem("set_user", JSON.stringify(data));
   };
   useEffect(() => {
      const ISSERVER = typeof window === "undefined";
      !ISSERVER && setUserState(JSON.parse(localStorage.getItem("set_user") || "{}"));
      !ISSERVER && console.log(JSON.parse(localStorage.getItem("set_user") || "{}"));
   }, []);
   const [fullLoading, setFullLoading] = useState(true);

   useEffect(() => {
      if (userState) {
         setFullLoading(false);
      }
   }, [userState]);
   useEffect(() => {
      console.log("normal");
      localStorage.removeItem("shop");
   }, []);
   return fullLoading ? (
      <CircularProgress />
   ) : (
      <div>
         <div className="text-block">
            <div className="base">
               <small>STEP 1 OF 3</small>
               <p>Personal Info</p>
            </div>
            <div className="info">
               <h2>
                  First step - set up your account, create and launch your new affiliate program in
                  minutes!
               </h2>
               <p>Metricks is free for 14 days, then $59 monthly to access it's full features.</p>
            </div>
         </div>
         {/* <div className="welcome-banner">
            <div className="heading">Thank you for choosing Metricks.</div>
            <div className="body">
               We are currently in <strong>BETA</strong> and are excited to share our product with
               early adopters. If you need help getting started, you can schedule an onboarding
               session{" "}
               <span
                  onClick={() => window.open("https://calendly.com/metricks/onboarding")}
                  style={{
                     color: "blue",
                     cursor: "pointer",
                     textDecoration: "underline",
                  }}
               >
                  here.
               </span>{" "}
               (This is optional, but recommended).
            </div>
         </div> */}

         <form onSubmit={handleSubmit(onSubmit)}>
            <CustomInput
               type="text"
               id="url"
               tag="This is your affiliates’ dashboard domain login URL. You can always change the address"
               label="Affiliate domain URL"
               preventSpaces={true}
               error={errors.domain?.message}
               defaultValue={userState?.domain}
               {...register("domain")}
            />

            <Input
               endAdornment
               label="First name"
               id="firstName"
               defaultValue={userState?.firstname}
               error={errors.firstname?.message}
               {...register("firstname")}
            />

            <Input
               endAdornment
               label="Last name"
               id="lastName"
               error={errors.lastname?.message}
               defaultValue={userState?.lastname}
               {...register("lastname")}
            />
            <Input
               endAdornment
               label="Email Address"
               id="email"
               error={errors.email?.message}
               defaultValue={userState?.email}
               {...register("email")}
            />
            <Input
               endAdornment
               label="Password"
               id="password"
               type="password"
               error={errors.password?.message}
               preventSpaces={true}
               tag="Atleast 8 characters including uppercase, lowercase, number, and a special character."
               defaultValue={userState?.password}
               {...register("password")}
            />
            <Input
               endAdornment
               label="Confirm Password"
               id="confirmPassword"
               type="password"
               preventSpaces={true}
               error={errors.confirmPassword?.message}
               defaultValue={userState?.password}
               {...register("confirmPassword")}
            />
            <div style={{ marginBottom: "2.0em" }}>
               <TC>
                  <input
                     style={{ width: "80px", height: "30px" }}
                     type="checkbox"
                     {...register("acceptTerms")}
                     id="accept"
                     checked={watch("acceptTerms")}
                  />
                  <p>
                     I have read and accepted Metricks’s
                     <Link href="/terms">
                        <a target="_blank" rel="noopener noreferrer">
                           Terms of Services
                        </a>
                     </Link>
                     and
                     <Link href="/privacy-policy">
                        <a target="_blank" rel="noopener noreferrer">
                           Privacy Policy
                        </a>
                     </Link>
                     and hereby agree to receive occasional communication with product news and
                     relevant educational content.
                  </p>
               </TC>
               {errors.acceptTerms && (
                  <ErrorP
                     initial="pageInitial"
                     animate="pageAnimate"
                     exit="pageExit"
                     variants={{
                        pageInitial: {
                           opacity: 1,
                           x: 0,
                           y: -5,
                        },
                        pageAnimate: {
                           opacity: 1,
                           x: 0,
                           y: 0,
                        },
                        pageExit: {
                           opacity: 0,
                        },
                     }}
                     id={"accept-message-text"}
                  >
                     {errors.acceptTerms.message}
                  </ErrorP>
               )}
            </div>

            <Button
               type="submit"
               variant="primary"
               className="ripple"
               fullWidth={true}
               isLoading={isLoading}
               style={{ fontSize: 16, fontWeight: 500 }}
            >
               {isLoading ? "loading...." : "CONTINUE"}
            </Button>
         </form>
      </div>
   );
};

export { Step1 };
